'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwDialog = require('./CwDialog.scss');

var _CwDialog2 = _interopRequireDefault(_CwDialog);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _CwImage = require('../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwDialog = function (_React$Component) {
  (0, _inherits3.default)(CwDialog, _React$Component);

  function CwDialog() {
    (0, _classCallCheck3.default)(this, CwDialog);
    return (0, _possibleConstructorReturn3.default)(this, (CwDialog.__proto__ || (0, _getPrototypeOf2.default)(CwDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(CwDialog, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          'data-cwid': this.props.cwId,
          ref: function ref(dialog) {
            return _this2.dialog = dialog;
          },
          className: (0, _classnames2.default)(this.props.className, _CwDialog2.default.modal),
          style: (0, _assign2.default)({ zIndex: this.props.zIndex }, this.props.style),
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur },
        this.props.includeMobileCloseIcon ? _react2.default.createElement(_CwImage2.default, { className: _CwDialog2.default.mobileCloseIcon, src: this.props.closeIcon, onClick: this.props.onCloseIconClicked }) : null,
        this.props.includeCloseIcon ? _react2.default.createElement(_CwImage2.default, { className: _CwDialog2.default.closeIcon, src: this.props.closeIcon, onClick: this.props.onCloseIconClicked }) : null,
        _react2.default.createElement(
          'div',
          { className: _CwDialog2.default.wrap },
          this.props.header ? _react2.default.createElement(
            'div',
            { className: _CwDialog2.default.header },
            this.props.header
          ) : null,
          this.props.children,
          this.props.buttons ? _react2.default.createElement(
            'div',
            { className: _CwDialog2.default.buttons },
            ' ',
            this.props.buttons,
            ' '
          ) : null
        )
      );
    }
  }]);
  return CwDialog;
}(_react2.default.Component);

;

CwDialog.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Content to be shown in the Dialog
   */
  children: _propTypes2.default.any,
  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes2.default.string,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * Array of buttons aligned in the bottom right corner
   */
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.element),
  /**
   * Specifies the z-index of the dialog box
   */
  zIndex: _propTypes2.default.number,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * True to include close icon inside on top right of dialog
   */
  includeMobileCloseIcon: _propTypes2.default.bool,
  /**
   * True to include close icon outside on of top right of dialog
   */
  includeCloseIcon: _propTypes2.default.bool,
  /**
   * Icon for close button on top right
   */
  closeIcon: _propTypes2.default.string,
  /**
   * Callback function for close button clicked.
   * Consumer should use this prop to close/hide dialog
   */
  onCloseIconClicked: _propTypes2.default.func
};

CwDialog.defaultProps = {
  zIndex: 1,
  closeIcon: _IconPath2.default.get('Action_Close')
};

exports.default = CwDialog;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwdialog/CwDialog.js
// module id = 224
// module chunks = 10